{
  "male": {
    "低い": {
      "1〜2（歳）": null,
      "3〜5（歳）": null,
      "6〜7（歳）": "1350",
      "8〜9（歳）": "1600",
      "10〜11（歳）": "1950",
      "12〜14（歳）": "2300",
      "15〜17（歳）": "2500",
      "18〜29（歳）": "2250",
      "30〜49（歳）": "2350",
      "50〜64（歳）": "2250",
      "65〜74（歳）": "2100",
      "75以上（歳）": "1850"
    },
    "ふつう": {
      "1〜2（歳）": "950",
      "3〜5（歳）": "1300",
      "6〜7（歳）": "1550",
      "8〜9（歳）": "1850",
      "10〜11（歳）": "2250",
      "12〜14（歳）": "2600",
      "15〜17（歳）": "2850",
      "18〜29（歳）": "2600",
      "30〜49（歳）": "2750",
      "50〜64（歳）": "2650",
      "65〜74（歳）": "2350",
      "75以上（歳）": "2250"
    },
    "高い": {
      "1〜2（歳）": null,
      "3〜5（歳）": null,
      "6〜7（歳）": "1750",
      "8〜9（歳）": "2100",
      "10〜11（歳）": "2500",
      "12〜14（歳）": "2900",
      "15〜17（歳）": "3150",
      "18〜29（歳）": "3000",
      "30〜49（歳）": "3150",
      "50〜64（歳）": "3000",
      "65〜74（歳）": "2650",
      "75以上（歳）": null
    }
  },
  "female": {
    "低い": {
      "1〜2（歳）": null,
      "3〜5（歳）": null,
      "6〜7（歳）": "1250",
      "8〜9（歳）": "1500",
      "10〜11（歳）": "1850",
      "12〜14（歳）": "2150",
      "15〜17（歳）": "2050",
      "18〜29（歳）": "1700",
      "30〜49（歳）": "1750",
      "50〜64（歳）": "1700",
      "65〜74（歳）": "1650",
      "75以上（歳）": "1450"
    },
    "ふつう": {
      "1〜2（歳）": "900",
      "3〜5（歳）": "1250",
      "6〜7（歳）": "1450",
      "8〜9（歳）": "1700",
      "10〜11（歳）": "2100",
      "12〜14（歳）": "2400",
      "15〜17（歳）": "2300",
      "18〜29（歳）": "1950",
      "30〜49（歳）": "2050",
      "50〜64（歳）": "1950",
      "65〜74（歳）": "1850",
      "75以上（歳）": "1750"
    },
    "高い": {
      "1〜2（歳）": null,
      "3〜5（歳）": null,
      "6〜7（歳）": "1650",
      "8〜9（歳）": "1900",
      "10〜11（歳）": "2350",
      "12〜14（歳）": "2700",
      "15〜17（歳）": "2550",
      "18〜29（歳）": "2250",
      "30〜49（歳）": "2350",
      "50〜64（歳）": "2250",
      "65〜74（歳）": "2050",
      "75以上（歳）": null
    }
  }
}